import { get } from 'services/api';

export const EVENTS_LOG_URL = '/i/events';

/** gets a JSON list of the user event log  */
export function getEventsLog() {
  return get(EVENTS_LOG_URL);
}
